import { useMemo } from 'react';
import queryString from 'query-string';

const withParameters = (BaseComponent) => {
  const WrappedComponent = (props) => {
    const search = props?.location?.search;
    const initialProps = useMemo(
      () =>
        queryString.parse(search, {
          parseBooleans: true,
          arrayFormat: 'comma',
        }),
      [search]
    );
    return <BaseComponent initialProps={initialProps} {...props} />;
  };
  return WrappedComponent;
};

export default withParameters;
